import { states } from './states';
import { city_data } from './data/city_data';
import { county_data } from './data/county_data';
import { district_data } from './data/district_data';
import { state_data } from './data/state_data';
import { form_logic } from './data/form_logic';

export interface City {
  city: string;
  county: string;
  population: number;
  competitive: boolean;
  seat_types: string[];
  notes: string;
}

export interface County {
  state: string;
  county: string;
  population: number;
  competitive?: boolean;
  notes?: string;
}

export interface District {
  district: string;
  seat_type: string;
  state: string;
  county: string;
  population: number;
  notes: string;
}

export interface State {
  population: number;
  capital: string;
  region: string;
  competitive?: boolean;
}

export const getStates = (): string[] => {
  return states;
};

export const getStateData = (state: string): State | undefined => {
  const data = state_data[state];
  if (data) {
    // Add competitiveness based on population and region
    return {
      ...data,
      competitive: data.population > 5000000 || ['Florida', 'Pennsylvania', 'Michigan', 'Wisconsin', 'Arizona', 'Georgia', 'Nevada'].includes(state)
    };
  }
  return undefined;
};

export const getCountiesForState = (state: string): County[] => {
  if (!state) return [];
  return county_data.counties
    .filter(county => county.state.toLowerCase() === state.toLowerCase())
    .map(county => ({
      ...county,
      competitive: county.population > 500000,
      notes: `Major population center with ${(county.population / 1000).toFixed(0)}k residents`
    }));
};

export const getCitiesForCounty = (state: string, county: string): City[] => {
  if (!state || !county) return [];
  const stateCities = city_data[state] || [];
  return stateCities.filter(city => 
    city.county.toLowerCase() === county.toLowerCase()
  );
};

export const getDistrictsForStateAndOffice = (state: string, office: string): District[] => {
  if (!state || !office) return [];
  const stateDistricts = district_data[state] || [];
  
  let seatType = office;
  if (office === "State Representative" || office === "State Senator") {
    seatType = office;
  } else if (office.includes("U.S. Representative")) {
    seatType = "U.S. Representative";
  }

  return stateDistricts.filter(district => 
    district.seat_type.toLowerCase() === seatType.toLowerCase()
  );
};

export const filterSuggestions = (items: any[], searchTerm: string, key?: string): any[] => {
  if (!items || !Array.isArray(items)) return [];
  if (!searchTerm) return items;
  
  const search = searchTerm.toLowerCase();
  return items.filter(item => {
    const value = key ? item[key]?.toLowerCase() : item?.toLowerCase();
    return value?.includes(search);
  });
};